"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sizes = void 0;
var Sizes = exports.Sizes = {
  FLEX: 'flex',
  LARGE: 'large',
  NORMAL: 'normal',
  TINY: 'tiny'
};